<script>
  import { onMount } from "svelte";
  import { ignore, makeWebsiteRequest } from "../../Common/tools";

  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  export let filters = [],
    funnel = null,
    period = null;

  export function reload() {
    load(0);
  }

  let loading = true,
    initialLoad = true,
    currentPage = 0,
    pagesCount = 0,
    itemsCount = 0,
    table = null,
    allOrdersTotal = 0,
    allOrdersCount = 0;

  let tableColumns = [
    { key: "image", type: "image", label: "", imageClass: "product-image-item", class: "flex-none product-td-image-wrapper flex align-center justify-center" },
    {
      key: "title",
      label: M.SAMPLE_PRODUCT_NAME_TEXT,
      class: "flex-1 mw-240",
      row: "modified",
      rowLabel: function (row, column) {
        return M["STORE_PRODUCT_" + row.type];
      }
    },
    { key: "unitsSold", label: M.UNITS_SOLD, class: "flex-none mw-120", style: "font-size: 15px" },
    { key: "ordersCount", label: M.ORDERS, class: "flex-none mw-120", style: "font-size: 15px" },
    { key: "total", label: M.REVENUE, class: "flex-none mw-140", style: "font-size: 15px" },
    { key: "ofAll", label: M.PERCENT_OF_REVENUE, class: "flex-none mw-140", type: "progressbar" },
    {
      type: "icon",
      label: "",
      class: "flex-none mw-140 none",
      iconClass: "material-icons-outlined circle-effect table-circle-button",
      iconText: "analytics",
      onClick: (row, column) => {}
    }
  ];

  let tableData = {
    columns: tableColumns,
    rows: []
  };

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      tableData.rows = [];
    } else if (currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let response = await makeWebsiteRequest({
      action: "getOrderStats",
      method: "post",
      data: {
        type: "top-performers",
        grouping: "products",
        funnel: funnel,
        page: page,
        from: period && period.from ? External.Tools.dateToISOStr(period.from) : null,
        to: period && period.to ? External.Tools.dateToISOStr(period.to) : null,
        filters: JSON.stringify(filters)
      }
    });

    loading = false;
    if (!response.data) return;

    let products = response.data.products;

    currentPage = page;
    pagesCount = products.pagesCount;
    itemsCount = products.count;

    if (page === 0) {
      allOrdersCount = response.data.orders;
      allOrdersTotal = response.data.sales;
    }

    products.items.forEach((item) => {
      let image = External.resources + "/images/image-avatar.png";
      if (item.images && item.images.length) {
        image = External.getThumbnailsFromBase(item.images[0].base, "72x50", true) + item.images[0].name;
      }
      item.image = image;
      item.title = item.title || "-";
      item.ofAll = item.total / allOrdersTotal;
      item.total = External.Tools.currencyToStrWithSymbol(item.total);
    });

    if (table) {
      table.addRows(products.items);
    }
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  let onClickRow = (row) => {
    if (!row.id) {
      return;
    }

    External.UITools.editProductInPopup(row.id, ignore);
    /*
    Tools.closeAllPopups(() => {
      CPanel.goToUrl("/me/store/products/" + row.id);
    });
    */
  };

  onMount(() => {
    load(0);
  });
</script>

<Table
  bind:this={table}
  hasSelection={false}
  activeColumns={tableData.columns}
  data={tableData.rows}
  loading={loading}
  hideHeadOnLoad={true}
  nextPage={onNext}
  onClick={onClickRow}
  tableClass={"products-scrollable-table mt-25"}>
  <div class="col20 f-left coming-soon-block">
    <div class="col20 f-left t-center mb-25">
      <span class="material-icons-outlined fingerprint-icon" style="background: #f5f6fa;"> bubble_chart </span>
    </div>
    <div class="col20 f-left t-center">
      <h3>{M.NO_DATA_YET}</h3>
    </div>
  </div>
</Table>
